import React, { useEffect, useContext } from "react";
import webRootContext from "../components/webrootcontext/WebRootContext";
import { AppConfiguration } from "../framework/AppConfigProvider";
import { USER_OBJECT } from "../components/UserObject";
import { UserProfile } from "../components/UserProfileProvider";   /* Need to override UserProfile */

function Logout(props) {

	let url = webRootContext + "/rest/usermanagement/logout";

	const localConfig = useContext(AppConfiguration);


  //Retrieve and display user profile info from the context.
  	const currentContext = useContext(UserProfile);
  	currentContext.userProfile = USER_OBJECT;
	sessionStorage.setItem("isLoggedIn", false);
	sessionStorage.removeItem("isLoggedIn");
	sessionStorage.clear();
	localStorage.clear();
	
	useEffect(() => {		
		props.updateTitle({"long":localConfig.configProperties.applicationName,"short":localConfig.configProperties.applicationNameAbbrev});	
		props.updateUserInHeader({"firstName":"","lastname":""});	
		
	  	currentContext.userProfile = USER_OBJECT;
		sessionStorage.removeItem("isLoggedIn");

	    fetch(url, {
  			method: 'get',
  			mode:"no-cors"})
   		 .then((response) => {
			 console.log("User should be logged out:", response);
			   			    
		 })
					
	},[props, localConfig]); // eslint-disable-line
  
	
  function navLogin(){
	  window.location.href =  webRootContext + "/Login"; 
  }
  return (
    <>
      <div>

              <div class="div_1_col">
                <div class="ribbon">
                  <div class="ribbon_title checkmark"></div>
                  <div class="ribbon_icon--checkmark"></div>
                  <div>
                    <label>LOG OUT SUCCESSFUL</label>
                  </div>
                  <div class="ribbon_content">You have successfully logged out of Observership application. Log in again to start a new session.</div>
                  <div class="ribbon_content"> 
                  	<button type="button"  class="button button--primary" onClick={() => navLogin()}>LOG IN</button>
                  </div>
                </div>
              </div>

        
      </div>
    </>
  );
}

export default Logout;

